
import { Component, Vue } from 'vue-property-decorator'
import AppNew from '@/components/AppNew.vue'
import AppList from '@/components/AppList.vue'

@Component({ components: { AppNew, AppList } })
export default class Apps extends Vue {
}
